import { parseJsonArray } from "./parseJsonArray";

const ACCENTS = ["coral", "gold", "sky", "berry"];

const ACCENT_ALIASES = {
  red: "coral",
  coral: "coral",
  primary: "coral",
  gold: "gold",
  yellow: "gold",
  accent: "gold",
  sky: "sky",
  blue: "sky",
  berry: "berry",
  pink: "berry",
};

export function normalizeAccent(raw, index) {
  if (!raw) return ACCENTS[index % ACCENTS.length];
  const key = String(raw).trim().toLowerCase();
  return ACCENT_ALIASES[key] || ACCENTS[index % ACCENTS.length];
}

export function normalizeProgramHighlights(raw) {
  const items = parseJsonArray(raw);
  if (!items?.length) return [];

  return items
    .map((item, index) => ({
      title: (item.title || item.name || "").trim(),
      text: (item.text || item.description || "").trim(),
      accent: normalizeAccent(item.accent || item.color, index),
    }))
    .filter((item) => item.title)
    .slice(0, 4);
}
